var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSweing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 73,
    viewBox: "0 0 141 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3621 24.0175H60.4828V21.386C60.4828 20.8596 60.131 20.5088 59.6035 20.5088H56.0862V17.8772C56.0862 17.3509 55.7345 17 55.2069 17H51.6897C51.1621 17 50.8103 17.3509 50.8103 17.8772V20.5088H26.1897V17.8772C26.1897 17.3509 25.8379 17 25.3103 17H21.7931C21.2655 17 20.9138 17.3509 20.9138 17.8772V20.5088H15.6379C15.1103 20.5088 14.7586 20.8596 14.7586 21.386V32.7895C14.7586 33.3158 15.1103 33.6667 15.6379 33.6667H16.5172V36.2982C16.5172 36.8246 16.869 37.1754 17.3966 37.1754H19.1552V41.5614C19.1552 42.0877 19.5069 42.4386 20.0345 42.4386H21.7931V45.9474C21.7931 46.4737 22.1448 46.8246 22.6724 46.8246C23.2 46.8246 23.5517 46.4737 23.5517 45.9474V42.4386H25.3103C25.8379 42.4386 26.1897 42.0877 26.1897 41.5614V37.1754H27.9483C28.4759 37.1754 28.8276 36.8246 28.8276 36.2982V33.6667H31.4655C35.95 33.6667 40.0828 35.4211 43.2483 38.5789C46.2379 41.5614 47.9086 45.3333 48.0845 49.4561H32.169C31.8172 48.4035 30.85 47.7018 29.7069 47.7018H20.9138C19.7707 47.7018 18.8034 48.4035 18.4517 49.4561H15.6379C15.1103 49.4561 14.7586 49.807 14.7586 50.3333V61.7368H13.8793C13.3517 61.7368 13 62.0877 13 62.614V66.1228C13 66.6491 13.3517 67 13.8793 67H61.3621C61.8897 67 62.2414 66.6491 62.2414 66.1228V62.614C62.2414 62.0877 61.8897 61.7368 61.3621 61.7368H60.4828V41.5614H61.3621C62.8569 41.5614 64 40.4211 64 38.9298V26.6491C64 25.1579 62.8569 24.0175 61.3621 24.0175ZM52.569 18.7544H54.3276V20.5088H52.569V18.7544ZM22.6724 18.7544H24.431V20.5088H22.6724V18.7544ZM24.431 40.6842H20.9138V37.1754H24.431V40.6842ZM27.069 35.4211H18.2759V33.6667H27.069V35.4211ZM20.9138 49.4561H29.7069C30.2345 49.4561 30.5862 49.807 30.5862 50.3333V61.7368H20.0345V50.3333C20.0345 49.807 20.3862 49.4561 20.9138 49.4561ZM16.5172 51.2105H18.2759V61.7368H16.5172V51.2105ZM60.4828 65.2456H14.7586V63.4912H60.4828V65.2456ZM32.3448 61.7368V51.2105H49.0517C49.5793 51.2105 49.931 50.8596 49.931 50.3333C49.931 45.4211 47.9966 40.7719 44.4793 37.3509C40.9621 33.8421 36.3897 31.9123 31.4655 31.9123H16.5172V22.2632H58.7241V61.7368H32.3448ZM62.2414 38.9298C62.2414 39.4561 61.8897 39.807 61.3621 39.807H60.4828V25.7719H61.3621C61.8897 25.7719 62.2414 26.1228 62.2414 26.6491V38.9298Z",
    fill: "url(#paint0_linear_504_5381)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6724 53.8421C23.2 53.8421 23.5517 53.4912 23.5517 52.9649V52.0877C23.5517 51.5614 23.2 51.2105 22.6724 51.2105C22.1448 51.2105 21.7931 51.5614 21.7931 52.0877V52.9649C21.7931 53.4912 22.1448 53.8421 22.6724 53.8421Z",
    fill: "url(#paint1_linear_504_5381)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6724 57.3509C23.2 57.3509 23.5517 57 23.5517 56.4737V55.5965C23.5517 55.0702 23.2 54.7193 22.6724 54.7193C22.1448 54.7193 21.7931 55.0702 21.7931 55.5965V56.4737C21.7931 57 22.1448 57.3509 22.6724 57.3509Z",
    fill: "url(#paint2_linear_504_5381)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6724 60.8596C23.2 60.8596 23.5517 60.5088 23.5517 59.9825V59.1053C23.5517 58.5789 23.2 58.2281 22.6724 58.2281C22.1448 58.2281 21.7931 58.5789 21.7931 59.1053V59.9825C21.7931 60.5088 22.1448 60.8596 22.6724 60.8596Z",
    fill: "url(#paint3_linear_504_5381)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3103 28.4035H20.0345C19.5069 28.4035 19.1552 28.7544 19.1552 29.2807C19.1552 29.807 19.5069 30.1579 20.0345 30.1579H25.3103C25.8379 30.1579 26.1897 29.807 26.1897 29.2807C26.1897 28.7544 25.8379 28.4035 25.3103 28.4035Z",
    fill: "url(#paint4_linear_504_5381)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3103 24.8947H20.0345C19.5069 24.8947 19.1552 25.2456 19.1552 25.7719C19.1552 26.2982 19.5069 26.6491 20.0345 26.6491H25.3103C25.8379 26.6491 26.1897 26.2982 26.1897 25.7719C26.1897 25.2456 25.8379 24.8947 25.3103 24.8947Z",
    fill: "url(#paint5_linear_504_5381)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8103 24.0175C47.381 24.0175 44.6552 26.7368 44.6552 30.1579C44.6552 33.5789 47.381 36.2982 50.8103 36.2982C54.2397 36.2982 56.9655 33.5789 56.9655 30.1579C56.9655 26.7368 54.2397 24.0175 50.8103 24.0175ZM50.8103 34.5439C48.3483 34.5439 46.4138 32.614 46.4138 30.1579C46.4138 27.7018 48.3483 25.7719 50.8103 25.7719C53.2724 25.7719 55.2069 27.7018 55.2069 30.1579C55.2069 32.614 53.2724 34.5439 50.8103 34.5439Z",
    fill: "url(#paint6_linear_504_5381)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6379 24.0175H80.5172V21.386C80.5172 20.8596 80.869 20.5088 81.3965 20.5088H84.9138V17.8772C84.9138 17.3509 85.2655 17 85.7931 17H89.3103C89.8379 17 90.1897 17.3509 90.1897 17.8772V20.5088H114.81V17.8772C114.81 17.3509 115.162 17 115.69 17H119.207C119.734 17 120.086 17.3509 120.086 17.8772V20.5088H125.362C125.89 20.5088 126.241 20.8596 126.241 21.386V32.7895C126.241 33.3158 125.89 33.6667 125.362 33.6667H124.483V36.2982C124.483 36.8246 124.131 37.1754 123.603 37.1754H121.845V41.5614C121.845 42.0877 121.493 42.4386 120.966 42.4386H119.207V45.9474C119.207 46.4737 118.855 46.8246 118.328 46.8246C117.8 46.8246 117.448 46.4737 117.448 45.9474V42.4386H115.69C115.162 42.4386 114.81 42.0877 114.81 41.5614V37.1754H113.052C112.524 37.1754 112.172 36.8246 112.172 36.2982V33.6667H109.534C105.05 33.6667 100.917 35.4211 97.7517 38.5789C94.7621 41.5614 93.0914 45.3333 92.9155 49.4561H108.831C109.183 48.4035 110.15 47.7018 111.293 47.7018H120.086C121.229 47.7018 122.197 48.4035 122.548 49.4561H125.362C125.89 49.4561 126.241 49.807 126.241 50.3333V61.7368H127.121C127.648 61.7368 128 62.0877 128 62.614V66.1228C128 66.6491 127.648 67 127.121 67H79.6379C79.1103 67 78.7586 66.6491 78.7586 66.1228V62.614C78.7586 62.0877 79.1103 61.7368 79.6379 61.7368H80.5172V41.5614H79.6379C78.1431 41.5614 77 40.4211 77 38.9298V26.6491C77 25.1579 78.1431 24.0175 79.6379 24.0175ZM88.431 18.7544H86.6724V20.5088H88.431V18.7544ZM118.328 18.7544H116.569V20.5088H118.328V18.7544ZM116.569 40.6842H120.086V37.1754H116.569V40.6842ZM113.931 35.4211H122.724V33.6667H113.931V35.4211ZM120.086 49.4561H111.293C110.766 49.4561 110.414 49.807 110.414 50.3333V61.7368H120.966V50.3333C120.966 49.807 120.614 49.4561 120.086 49.4561ZM124.483 51.2105H122.724V61.7368H124.483V51.2105ZM80.5172 65.2456H126.241V63.4912H80.5172V65.2456ZM108.655 61.7368V51.2105H91.9483C91.4207 51.2105 91.069 50.8596 91.069 50.3333C91.069 45.4211 93.0034 40.7719 96.5207 37.3509C100.038 33.8421 104.61 31.9123 109.534 31.9123H124.483V22.2632H82.2759V61.7368H108.655ZM78.7586 38.9298C78.7586 39.4561 79.1103 39.807 79.6379 39.807H80.5172V25.7719H79.6379C79.1103 25.7719 78.7586 26.1228 78.7586 26.6491V38.9298Z",
    fill: "url(#paint7_linear_504_5381)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.328 53.8421C117.8 53.8421 117.448 53.4912 117.448 52.9649V52.0877C117.448 51.5614 117.8 51.2105 118.328 51.2105C118.855 51.2105 119.207 51.5614 119.207 52.0877V52.9649C119.207 53.4912 118.855 53.8421 118.328 53.8421Z",
    fill: "url(#paint8_linear_504_5381)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.328 57.3509C117.8 57.3509 117.448 57 117.448 56.4737V55.5965C117.448 55.0702 117.8 54.7193 118.328 54.7193C118.855 54.7193 119.207 55.0702 119.207 55.5965V56.4737C119.207 57 118.855 57.3509 118.328 57.3509Z",
    fill: "url(#paint9_linear_504_5381)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.328 60.8596C117.8 60.8596 117.448 60.5088 117.448 59.9825V59.1053C117.448 58.5789 117.8 58.2281 118.328 58.2281C118.855 58.2281 119.207 58.5789 119.207 59.1053V59.9825C119.207 60.5088 118.855 60.8596 118.328 60.8596Z",
    fill: "url(#paint10_linear_504_5381)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.69 28.4035H120.966C121.493 28.4035 121.845 28.7544 121.845 29.2807C121.845 29.807 121.493 30.1579 120.966 30.1579H115.69C115.162 30.1579 114.81 29.807 114.81 29.2807C114.81 28.7544 115.162 28.4035 115.69 28.4035Z",
    fill: "url(#paint11_linear_504_5381)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M115.69 24.8947H120.966C121.493 24.8947 121.845 25.2456 121.845 25.7719C121.845 26.2982 121.493 26.6491 120.966 26.6491H115.69C115.162 26.6491 114.81 26.2982 114.81 25.7719C114.81 25.2456 115.162 24.8947 115.69 24.8947Z",
    fill: "url(#paint12_linear_504_5381)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1897 24.0175C93.619 24.0175 96.3448 26.7368 96.3448 30.1579C96.3448 33.5789 93.619 36.2982 90.1897 36.2982C86.7603 36.2982 84.0345 33.5789 84.0345 30.1579C84.0345 26.7368 86.7603 24.0175 90.1897 24.0175ZM90.1897 34.5439C92.6517 34.5439 94.5862 32.614 94.5862 30.1579C94.5862 27.7018 92.6517 25.7719 90.1897 25.7719C87.7276 25.7719 85.7931 27.7018 85.7931 30.1579C85.7931 32.614 87.7276 34.5439 90.1897 34.5439Z",
    fill: "url(#paint13_linear_504_5381)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1379 27.9123H33.5172V26.0702C33.5172 25.7018 33.269 25.4561 32.8965 25.4561H30.4138V23.614C30.4138 23.2456 30.1655 23 29.7931 23H27.3103C26.9379 23 26.6897 23.2456 26.6897 23.614V25.4561H9.31034V23.614C9.31034 23.2456 9.06207 23 8.68966 23H6.2069C5.83448 23 5.58621 23.2456 5.58621 23.614V25.4561H1.86207C1.48966 25.4561 1.24138 25.7018 1.24138 26.0702V34.0526C1.24138 34.4211 1.48966 34.6667 1.86207 34.6667H2.48276V36.5088C2.48276 36.8772 2.73103 37.1228 3.10345 37.1228H4.34483V40.193C4.34483 40.5614 4.5931 40.807 4.96552 40.807H6.2069V43.2632C6.2069 43.6316 6.45517 43.8772 6.82759 43.8772C7.2 43.8772 7.44828 43.6316 7.44828 43.2632V40.807H8.68966C9.06207 40.807 9.31034 40.5614 9.31034 40.193V37.1228H10.5517C10.9241 37.1228 11.1724 36.8772 11.1724 36.5088V34.6667H13.0345C16.2 34.6667 19.1172 35.8947 21.3517 38.1053C23.4621 40.193 24.6414 42.8333 24.7655 45.7193H13.531C13.2828 44.9825 12.6 44.4912 11.7931 44.4912H5.58621C4.77931 44.4912 4.09655 44.9825 3.84828 45.7193H1.86207C1.48966 45.7193 1.24138 45.9649 1.24138 46.3333V54.3158H0.62069C0.248276 54.3158 0 54.5614 0 54.9298V57.386C0 57.7544 0.248276 58 0.62069 58H34.1379C34.5103 58 34.7586 57.7544 34.7586 57.386V54.9298C34.7586 54.5614 34.5103 54.3158 34.1379 54.3158H33.5172V40.193H34.1379C35.1931 40.193 36 39.3947 36 38.3509V29.7544C36 28.7105 35.1931 27.9123 34.1379 27.9123ZM27.931 24.2281H29.1724V25.4561H27.931V24.2281ZM6.82759 24.2281H8.06896V25.4561H6.82759V24.2281ZM8.06896 39.5789H5.58621V37.1228H8.06896V39.5789ZM9.93103 35.8947H3.72414V34.6667H9.93103V35.8947ZM5.58621 45.7193H11.7931C12.1655 45.7193 12.4138 45.9649 12.4138 46.3333V54.3158H4.96552V46.3333C4.96552 45.9649 5.21379 45.7193 5.58621 45.7193ZM2.48276 46.9474H3.72414V54.3158H2.48276V46.9474ZM33.5172 56.7719H1.24138V55.5439H33.5172V56.7719ZM13.6552 54.3158V46.9474H25.4483C25.8207 46.9474 26.069 46.7018 26.069 46.3333C26.069 42.8947 24.7034 39.6404 22.2207 37.2456C19.7379 34.7895 16.5103 33.4386 13.0345 33.4386H2.48276V26.6842H32.2759V54.3158H13.6552ZM34.7586 38.3509C34.7586 38.7193 34.5103 38.9649 34.1379 38.9649H33.5172V29.1404H34.1379C34.5103 29.1404 34.7586 29.386 34.7586 29.7544V38.3509Z",
    fill: "url(#paint14_linear_504_5381)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82759 48.7895C7.2 48.7895 7.44828 48.5439 7.44828 48.1754V47.5614C7.44828 47.193 7.2 46.9474 6.82759 46.9474C6.45517 46.9474 6.2069 47.193 6.2069 47.5614V48.1754C6.2069 48.5439 6.45517 48.7895 6.82759 48.7895Z",
    fill: "url(#paint15_linear_504_5381)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82759 51.2456C7.2 51.2456 7.44828 51 7.44828 50.6316V50.0175C7.44828 49.6491 7.2 49.4035 6.82759 49.4035C6.45517 49.4035 6.2069 49.6491 6.2069 50.0175V50.6316C6.2069 51 6.45517 51.2456 6.82759 51.2456Z",
    fill: "url(#paint16_linear_504_5381)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82759 53.7018C7.2 53.7018 7.44828 53.4561 7.44828 53.0877V52.4737C7.44828 52.1053 7.2 51.8596 6.82759 51.8596C6.45517 51.8596 6.2069 52.1053 6.2069 52.4737V53.0877C6.2069 53.4561 6.45517 53.7018 6.82759 53.7018Z",
    fill: "url(#paint17_linear_504_5381)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68966 30.9825H4.96552C4.5931 30.9825 4.34483 31.2281 4.34483 31.5965C4.34483 31.9649 4.5931 32.2105 4.96552 32.2105H8.68966C9.06207 32.2105 9.31034 31.9649 9.31034 31.5965C9.31034 31.2281 9.06207 30.9825 8.68966 30.9825Z",
    fill: "url(#paint18_linear_504_5381)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68966 28.5263H4.96552C4.5931 28.5263 4.34483 28.7719 4.34483 29.1404C4.34483 29.5088 4.5931 29.7544 4.96552 29.7544H8.68966C9.06207 29.7544 9.31034 29.5088 9.31034 29.1404C9.31034 28.7719 9.06207 28.5263 8.68966 28.5263Z",
    fill: "url(#paint19_linear_504_5381)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6897 27.9123C24.269 27.9123 22.3448 29.8158 22.3448 32.2105C22.3448 34.6053 24.269 36.5088 26.6897 36.5088C29.1103 36.5088 31.0345 34.6053 31.0345 32.2105C31.0345 29.8158 29.1103 27.9123 26.6897 27.9123ZM26.6897 35.2807C24.9517 35.2807 23.5862 33.9298 23.5862 32.2105C23.5862 30.4912 24.9517 29.1404 26.6897 29.1404C28.4276 29.1404 29.7931 30.4912 29.7931 32.2105C29.7931 33.9298 28.4276 35.2807 26.6897 35.2807Z",
    fill: "url(#paint20_linear_504_5381)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M106.862 27.9123H107.483V26.0702C107.483 25.7018 107.731 25.4561 108.103 25.4561H110.586V23.614C110.586 23.2456 110.834 23 111.207 23H113.69C114.062 23 114.31 23.2456 114.31 23.614V25.4561H131.69V23.614C131.69 23.2456 131.938 23 132.31 23H134.793C135.166 23 135.414 23.2456 135.414 23.614V25.4561H139.138C139.51 25.4561 139.759 25.7018 139.759 26.0702V34.0526C139.759 34.4211 139.51 34.6667 139.138 34.6667H138.517V36.5088C138.517 36.8772 138.269 37.1228 137.897 37.1228H136.655V40.193C136.655 40.5614 136.407 40.807 136.034 40.807H134.793V43.2632C134.793 43.6316 134.545 43.8772 134.172 43.8772C133.8 43.8772 133.552 43.6316 133.552 43.2632V40.807H132.31C131.938 40.807 131.69 40.5614 131.69 40.193V37.1228H130.448C130.076 37.1228 129.828 36.8772 129.828 36.5088V34.6667H127.966C124.8 34.6667 121.883 35.8947 119.648 38.1053C117.538 40.193 116.359 42.8333 116.234 45.7193H127.469C127.717 44.9825 128.4 44.4912 129.207 44.4912H135.414C136.221 44.4912 136.903 44.9825 137.152 45.7193H139.138C139.51 45.7193 139.759 45.9649 139.759 46.3333V54.3158H140.379C140.752 54.3158 141 54.5614 141 54.9298V57.386C141 57.7544 140.752 58 140.379 58H106.862C106.49 58 106.241 57.7544 106.241 57.386V54.9298C106.241 54.5614 106.49 54.3158 106.862 54.3158H107.483V40.193H106.862C105.807 40.193 105 39.3947 105 38.3509V29.7544C105 28.7105 105.807 27.9123 106.862 27.9123ZM113.069 24.2281H111.828V25.4561H113.069V24.2281ZM134.172 24.2281H132.931V25.4561H134.172V24.2281ZM132.931 39.5789H135.414V37.1228H132.931V39.5789ZM131.069 35.8947H137.276V34.6667H131.069V35.8947ZM135.414 45.7193H129.207C128.834 45.7193 128.586 45.9649 128.586 46.3333V54.3158H136.034V46.3333C136.034 45.9649 135.786 45.7193 135.414 45.7193ZM138.517 46.9474H137.276V54.3158H138.517V46.9474ZM107.483 56.7719H139.759V55.5439H107.483V56.7719ZM127.345 54.3158V46.9474H115.552C115.179 46.9474 114.931 46.7018 114.931 46.3333C114.931 42.8947 116.297 39.6404 118.779 37.2456C121.262 34.7895 124.49 33.4386 127.966 33.4386H138.517V26.6842H108.724V54.3158H127.345ZM106.241 38.3509C106.241 38.7193 106.49 38.9649 106.862 38.9649H107.483V29.1404H106.862C106.49 29.1404 106.241 29.386 106.241 29.7544V38.3509Z",
    fill: "url(#paint21_linear_504_5381)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M134.172 48.7895C133.8 48.7895 133.552 48.5439 133.552 48.1754V47.5614C133.552 47.193 133.8 46.9474 134.172 46.9474C134.545 46.9474 134.793 47.193 134.793 47.5614V48.1754C134.793 48.5439 134.545 48.7895 134.172 48.7895Z",
    fill: "url(#paint22_linear_504_5381)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M134.172 51.2456C133.8 51.2456 133.552 51 133.552 50.6316V50.0175C133.552 49.6491 133.8 49.4035 134.172 49.4035C134.545 49.4035 134.793 49.6491 134.793 50.0175V50.6316C134.793 51 134.545 51.2456 134.172 51.2456Z",
    fill: "url(#paint23_linear_504_5381)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M134.172 53.7018C133.8 53.7018 133.552 53.4561 133.552 53.0877V52.4737C133.552 52.1053 133.8 51.8596 134.172 51.8596C134.545 51.8596 134.793 52.1053 134.793 52.4737V53.0877C134.793 53.4561 134.545 53.7018 134.172 53.7018Z",
    fill: "url(#paint24_linear_504_5381)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M132.31 30.9825H136.034C136.407 30.9825 136.655 31.2281 136.655 31.5965C136.655 31.9649 136.407 32.2105 136.034 32.2105H132.31C131.938 32.2105 131.69 31.9649 131.69 31.5965C131.69 31.2281 131.938 30.9825 132.31 30.9825Z",
    fill: "url(#paint25_linear_504_5381)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M132.31 28.5263H136.034C136.407 28.5263 136.655 28.7719 136.655 29.1404C136.655 29.5088 136.407 29.7544 136.034 29.7544H132.31C131.938 29.7544 131.69 29.5088 131.69 29.1404C131.69 28.7719 131.938 28.5263 132.31 28.5263Z",
    fill: "url(#paint26_linear_504_5381)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M114.31 27.9123C116.731 27.9123 118.655 29.8158 118.655 32.2105C118.655 34.6053 116.731 36.5088 114.31 36.5088C111.89 36.5088 109.966 34.6053 109.966 32.2105C109.966 29.8158 111.89 27.9123 114.31 27.9123ZM114.31 35.2807C116.048 35.2807 117.414 33.9298 117.414 32.2105C117.414 30.4912 116.048 29.1404 114.31 29.1404C112.572 29.1404 111.207 30.4912 111.207 32.2105C111.207 33.9298 112.572 35.2807 114.31 35.2807Z",
    fill: "url(#paint27_linear_504_5381)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4386 10.2456H98.1579V6.40351C98.1579 5.63509 97.6456 5.12281 96.8772 5.12281H91.7544V1.2807C91.7544 0.512281 91.2421 0 90.4737 0H85.3509C84.5825 0 84.0702 0.512281 84.0702 1.2807V5.12281H48.2105V1.2807C48.2105 0.512281 47.6982 0 46.9298 0H41.807C41.0386 0 40.5263 0.512281 40.5263 1.2807V5.12281H32.8421C32.0737 5.12281 31.5614 5.63509 31.5614 6.40351V23.0526C31.5614 23.8211 32.0737 24.3333 32.8421 24.3333H34.1228V28.1754C34.1228 28.9439 34.6351 29.4561 35.4035 29.4561H37.9649V35.8596C37.9649 36.6281 38.4772 37.1404 39.2456 37.1404H41.807V42.2632C41.807 43.0316 42.3193 43.5439 43.0877 43.5439C43.8561 43.5439 44.3684 43.0316 44.3684 42.2632V37.1404H46.9298C47.6982 37.1404 48.2105 36.6281 48.2105 35.8596V29.4561H50.7719C51.5404 29.4561 52.0526 28.9439 52.0526 28.1754V24.3333H55.8947C62.4263 24.3333 68.4456 26.8947 73.0561 31.5053C77.4105 35.8596 79.8439 41.3667 80.1 47.386H56.9193C56.407 45.8491 54.9982 44.8246 53.3333 44.8246H40.5263C38.8614 44.8246 37.4526 45.8491 36.9404 47.386H32.8421C32.0737 47.386 31.5614 47.8982 31.5614 48.6667V65.3158H30.2807C29.5123 65.3158 29 65.8281 29 66.5965V71.7193C29 72.4877 29.5123 73 30.2807 73H99.4386C100.207 73 100.719 72.4877 100.719 71.7193V66.5965C100.719 65.8281 100.207 65.3158 99.4386 65.3158H98.1579V35.8596H99.4386C101.616 35.8596 103.281 34.1947 103.281 32.0175V14.0877C103.281 11.9105 101.616 10.2456 99.4386 10.2456ZM86.6316 2.5614H89.193V5.12281H86.6316V2.5614ZM43.0877 2.5614H45.6491V5.12281H43.0877V2.5614ZM45.6491 34.5789H40.5263V29.4561H45.6491V34.5789ZM49.4912 26.8947H46.9298H39.2456H36.6842V24.3333H49.4912V26.8947ZM40.5263 47.386H53.3333C54.1018 47.386 54.614 47.8982 54.614 48.6667V65.3158H39.2456V48.6667C39.2456 47.8982 39.7579 47.386 40.5263 47.386ZM34.1228 49.9474H36.6842V65.3158H34.1228V49.9474ZM98.1579 70.4386H31.5614V67.8772H32.8421H37.9649H55.8947H96.8772H98.1579V70.4386ZM57.1754 65.3158V49.9474H81.5088C82.2772 49.9474 82.7895 49.4351 82.7895 48.6667C82.7895 41.4947 79.9719 34.707 74.8491 29.7123C69.7263 24.5895 63.0667 21.7719 55.8947 21.7719H50.7719H35.4035H34.1228V7.68421H41.807H46.9298H85.3509H90.4737H95.5965V11.5263V34.5789V65.3158H57.1754ZM100.719 32.0175C100.719 32.786 100.207 33.2982 99.4386 33.2982H98.1579V12.807H99.4386C100.207 12.807 100.719 13.3193 100.719 14.0877V32.0175Z",
    fill: "#D65B03"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0878 53.7895C43.8563 53.7895 44.3685 53.2772 44.3685 52.5088V51.2281C44.3685 50.4597 43.8563 49.9474 43.0878 49.9474C42.3194 49.9474 41.8071 50.4597 41.8071 51.2281V52.5088C41.8071 53.2772 42.3194 53.7895 43.0878 53.7895Z",
    fill: "#D65B03"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0878 58.9123C43.8563 58.9123 44.3685 58.4 44.3685 57.6316V56.3509C44.3685 55.5825 43.8563 55.0702 43.0878 55.0702C42.3194 55.0702 41.8071 55.5825 41.8071 56.3509V57.6316C41.8071 58.4 42.3194 58.9123 43.0878 58.9123Z",
    fill: "#D65B03"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0878 64.0351C43.8563 64.0351 44.3685 63.5228 44.3685 62.7544V61.4737C44.3685 60.7053 43.8563 60.193 43.0878 60.193C42.3194 60.193 41.8071 60.7053 41.8071 61.4737V62.7544C41.8071 63.5228 42.3194 64.0351 43.0878 64.0351Z",
    fill: "#D65B03"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9298 16.6492H39.2455C38.4771 16.6492 37.9648 17.1615 37.9648 17.9299C37.9648 18.6983 38.4771 19.2106 39.2455 19.2106H46.9298C47.6982 19.2106 48.2105 18.6983 48.2105 17.9299C48.2105 17.1615 47.6982 16.6492 46.9298 16.6492Z",
    fill: "#D65B03"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9298 11.5264H39.2455C38.4771 11.5264 37.9648 12.0386 37.9648 12.8071C37.9648 13.5755 38.4771 14.0878 39.2455 14.0878H46.9298C47.6982 14.0878 48.2105 13.5755 48.2105 12.8071C48.2105 12.0386 47.6982 11.5264 46.9298 11.5264Z",
    fill: "#D65B03"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0704 10.2456C79.0756 10.2456 75.1055 14.2158 75.1055 19.2105C75.1055 24.2053 79.0756 28.1754 84.0704 28.1754C89.0651 28.1754 93.0353 24.2053 93.0353 19.2105C93.0353 14.2158 89.0651 10.2456 84.0704 10.2456ZM84.0704 25.614C80.4844 25.614 77.6669 22.7965 77.6669 19.2105C77.6669 15.6246 80.4844 12.807 84.0704 12.807C87.6563 12.807 90.4739 15.6246 90.4739 19.2105C90.4739 22.7965 87.6563 25.614 84.0704 25.614Z",
    fill: "#D65B03"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_504_5381",
    x1: 22.6724,
    y1: 32.3509,
    x2: 45.5402,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_504_5381",
    x1: 118.328,
    y1: 32.3509,
    x2: 95.4598,
    y2: 35.8223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_504_5381",
    x1: 2.17241,
    y1: 34.0526,
    x2: 22.3447,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_504_5381",
    x1: 138.828,
    y1: 34.0526,
    x2: 118.655,
    y2: 34.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822152,
    stopColor: "#262626",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSweing);
export default __webpack_public_path__ + "static/media/sweing.858be4346f4de33fa31e243932826634.svg";
export { ForwardRef as ReactComponent };